import * as React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import { ThemeProvider } from "@material-ui/styles";
import defiTheme from "../themes/defiTheme";
const Checker = props => {
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: defiTheme
  }, /*#__PURE__*/React.createElement(Checkbox, {
    className: props.testClass,
    checked: typeof props.checked === "function" ? props.checked(props.appId) : props.checked,
    onClick: () => props.onClick(props.appId, () => {
      if (typeof props.checked === "function") props.checked(props.appId);
    }),
    value: props.value,
    color: "primary",
    "data-test": props.testClass,
    "data-testid": "checker",
    disabled: props.disabled,
    style: props.style
  }));
};
export default Checker;